// Evidence capture helpers: SHA-256 of the ORIGINAL file, GPS fix, UTC stamp, size-safe upload copy.
export const sha256Hex = async (blob) => {
  const buf = await blob.arrayBuffer();
  const hash = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(hash)).map((b) => b.toString(16).padStart(2, "0")).join("");
};

export const getGps = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 7000, maximumAge: 60000 }
    );
  });

const MAX_EDGE = 3000;
const MAX_BYTES = 3.5 * 1024 * 1024;

export const uploadCopy = async (file) => {
  if (file.size <= MAX_BYTES) return file;
  const bmp = await createImageBitmap(file);
  const scale = Math.min(1, MAX_EDGE / Math.max(bmp.width, bmp.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(bmp.width * scale);
  canvas.height = Math.round(bmp.height * scale);
  canvas.getContext("2d").drawImage(bmp, 0, 0, canvas.width, canvas.height);
  const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.88));
  return blob || file;
};

export const buildPhotoForm = async ({ file, roomKey, shotKey }) => {
  const [original, gps, copy] = await Promise.all([sha256Hex(file), getGps(), uploadCopy(file)]);
  const form = new FormData();
  form.append("room_key", roomKey);
  form.append("shot_key", shotKey);
  form.append("captured_at_utc", new Date().toISOString());
  form.append("client_sha256", original);
  if (gps) {
    form.append("gps_lat", gps.lat);
    form.append("gps_lng", gps.lng);
    form.append("gps_accuracy_m", gps.accuracy);
  }
  form.append("file", copy, (file.name || "shot").replace(/\.\w+$/, "") + ".jpg");
  return { form, gps };
};
